import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DnDXmlZipFile } from "./components/DndXmlZipFile";
import { FilterXmlZipFile } from "./components/FilterXmlZipFile";
import { uploadXmlZipFileAction } from "../../../redux/action/uploadXmlZipFile";
import { message } from "antd";
import { UPLOAD_FILE_RESET, UPLOAD_XML_ZIP_FILE_RESET } from "../../../redux/action/actionType";

export const UploadsXmlZipFile = () => {
  const dispatch = useDispatch();
  const { uploadXmlZipFile } = useSelector((state) => {
    return {
      uploadXmlZipFile: state.uploadXmlZipFileReducer,
    };
  });

  const [formData, setFormData] = useState({
    cycleNo: "",
    fileType: "",
    date: "",
  });
  const [file, setFile] = useState(null);
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);

  const handleSubmit = () => {
    if (!file) {
      message.destroy();
      message.warning("No file selected!");
      return;
    }

    const form = new FormData();
    form.append("cycleNo", formData.cycleNo);
    form.append("file", file);

    dispatch(uploadXmlZipFileAction(form));
  };

  useEffect(() => {
    if (uploadXmlZipFile?.loading === true) {
      // message.destroy();
      message.loading({
        content: "Uploading file...",
      });
    } else if (uploadXmlZipFile?.loading === false&&uploadXmlZipFile?.data!==null) {
      message.destroy();
      message
        .success({
          content: "File uploaded successfully!",
          duration: 2,
        })
        .then(() => dispatch({ type: UPLOAD_XML_ZIP_FILE_RESET }));
    } else if (
      uploadXmlZipFile?.loading === false &&
      uploadXmlZipFile?.error !== null
    ) {
      message.destroy();
      message
        .error({
          content: uploadXmlZipFile?.error?.message || "File uploading failed",
          duration: 2,
        })
        .then(() =>
          dispatch({
            type: UPLOAD_FILE_RESET,
          })
        );
    }
  }, [uploadXmlZipFile]);

  useEffect(() => {
    if (!file || formData.cycleNo === "") {
      setDisableSubmitButton(true);
    } else {
      setDisableSubmitButton(false);
    }
  }, [file, formData]);

  return (
    <div className="w-full">
      <div className="mt-5 w-full">
        <FilterXmlZipFile
          handleSubmit={handleSubmit}
          setFormData={setFormData}
          disableSubmitButton={disableSubmitButton}
          formData={formData}
        />
        <DnDXmlZipFile setFormDataState={setFile} />
      </div>
    </div>
  );
};
